
import {
    createVNode
} from 'vue';
import {
    ExclamationCircleOutlined,
    DeleteOutlined,
    PlusOutlined,
    UploadOutlined
} from '@ant-design/icons-vue';
import Editor from './editor';
import OrderUpload from "./address_upload.vue"

export default {
    name: "BasicAddressBook",
    components: {
        DeleteOutlined,
        PlusOutlined,
        UploadOutlined,
        Editor,
        OrderUpload
    },
    data() {
        return {
            url: '/admin/address_book/list',
            // 表格搜索条件
            where: {},
            // 表格选中数据
            selection: [],
            // 当前编辑数据
            current: null,
            // 是否显示编辑弹窗
            showEdit: false,
            // 导入地址Loading状态
            import_loading: false,
            // 导入地址簿
            showImportModal: false,
            // 文件导入
            fileList: []
        };
    },
    computed: {
        columns() {
            return [{
                    key: 'index',
                    width: 48,
                    customRender: ({
                        index
                    }) => this.$refs.table.tableIndex + index
                },
                {
                    title: this.$t('名称'),
                    dataIndex: 'name',
                    width: 200,
                    sorter: true,
                    slots: {
                        customRender: 'name'
                    }
                },
                {
                    title: this.$t('地址'),
                    dataIndex: 'address1',
                    sorter: true,
                    className: "max-address",
                    slots: {
                        customRender: 'address'
                    }
                },
                {
                    title: this.$t('城市'),
                    dataIndex: 'city',
                    sorter: true,
                    width: 150
                },
                {
                    title: this.$t('省/洲/地区'),
                    dataIndex: 'state_code',
                    width: 150,
                    sorter: true
                },
                {
                    title: this.$t('邮编'),
                    dataIndex: 'postal_code',
                    width: 100,
                    sorter: true
                },
                {
                    title: this.$t('国家/地区'),
                    dataIndex: 'country_code',
                    width: 100,
                    sorter: true
                },
                {
                    title: this.$t('电话号码'),
                    dataIndex: 'phone_number',
                    width: 150,
                    sorter: true
                },
                {
                    title: this.$t('创建时间'),
                    dataIndex: 'created',
                    width: 100,
                    sorter: true
                },
                {
                    title: this.$t('操作'),
                    key: 'action',
                    width: 120,
                    align: 'center',
                    slots: {
                        customRender: 'action'
                    }
                }
            ]
        }
    },
    methods: {
        /* 搜索 */
        reload() {
            this.selection = [];
            this.$refs.table.reload({
                page: 1
            });
        },
        /*  重置搜索 */
        reset() {
            this.where = {};
            this.$nextTick(() => {
                this.reload();
            });
        },
        /**
         * 新建
         */
        createNew() {
            this.current = null;
            this.showEdit = true;
        },
        /* 打开编辑弹窗 */
        openEdit(row) {
            this.current = row;
            this.showEdit = true;
        },
        /* 删除单个 */
        remove(row) {
            const hide = this.$message.loading('请求中...', 0);

            this.$http.post('/admin/address_book/delete/', {
                ids: [row.id]
            }).then(res => {
                hide();
                if (res.data.code === 0) {
                    this.$message.success(res.data.msg);
                    this.reload();
                } else {
                    this.$message.error(res.data.msg);
                }
            }).catch(e => {
                hide();
                this.$message.error(e.message);
            });
        },
        /* 批量删除 */
        removeBatch() {
            if (!this.selection.length) {
                return this.$message.error('请至少选择一条数据');
            }

            this.$confirm({
                title: this.$t('提示'),
                content: this.$t('确定要删除选中的数据吗?'),
                icon: createVNode(ExclamationCircleOutlined),
                maskClosable: true,
                onOk: () => {
                    const hide = this.$message.loading('请求中...', 0);

                    this.$http.post('/admin/address_book/delete/', {
                        ids: this.selection.map(d => d.id)
                    }).then(res => {
                        hide();
                        if (res.data.code === 0) {
                            this.$message.success(res.data.msg);
                            this.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        hide();
                        this.$message.error(e.message);
                    });
                }
            });
        }
    }
}
